import { defineDirective } from "../../utils/angular"
import { addListener, isArray, isNumber, isUndefinedOrNull } from "../../utils/utils"

/** @internal */
export class MapLayerOpacityCtrl {

    static create() {

        const def = defineDirective(MapLayerOpacityCtrl, "shared/map/layer-opacity/layer-opacity.html", {
            layer: "<",
        })

        def.link = (scope, element: JQLite, attrs, ctrl: any) => ctrl.link(element)

        return def

    }

    private rootElt: HTMLElement
    private marker: HTMLElement

    private listeners: Function[]

    layer: {
        opacity: number
    }

    static $inject = ["$scope", "$document"]

    constructor(private $scope: ng.IScope, private $document: ng.IDocumentService) {
    }

    $onInit() {
        this.$scope.$watch("vm.layer.opacity", () => this.setOpacity())
        this.setup()
    }

    link(e: JQLite) {

        this.rootElt = e[0]
        this.marker = <HTMLElement>this.rootElt.getElementsByClassName("marker")[0]

        this.setup()

    }

    $onDestroy() {
        this.dispose()
    }

    private dispose() {

        if (isArray(this.listeners)) {
            this.listeners.forEach(f => f())
            this.listeners = undefined
        }

    }

    private setOpacity(value?: number) {

        const marker = this.marker

        if (marker && this.layer) {

            const updateLayer = !isUndefinedOrNull(value)
            value = updateLayer ? value : this.layer.opacity

            marker.innerHTML = `<span>${Math.round(value)}</span>`
            marker.style.left = value + "%"

            if (updateLayer) {
                this.layer.opacity = value
                this.$scope.$applyAsync()
            }

        }

    }

    private setup() {

        if (this.rootElt) {

            this.dispose()

            const marker = this.marker
            const bar = this.rootElt.getElementsByClassName("bar")[0]
            const doc = this.$document[0]

            let dragOrigin: number
            let rect: ClientRect

            const setOpacityFromClientX = (clientX: number) => {
                const pct = Math.round(100 * Math.max(0, Math.min(1, (clientX - rect.left) / rect.width)))
                this.setOpacity(pct)
            }

            const handleMove = (e: Event, clientX: number) => {

                if (dragOrigin && rect && isNumber(clientX)) {
                    e.preventDefault()
                    setOpacityFromClientX(clientX)
                }

            }

            this.listeners = [

                addListener(marker, "pointerdown", (e: PointerEvent) => {
                    dragOrigin = e.clientX
                    rect = bar.getBoundingClientRect()
                }),

                addListener(doc, "pointerup", () => {
                    dragOrigin = rect = undefined
                }),

                addListener(doc, "pointermove", (e: PointerEvent) => handleMove(e, e.clientX)),

                addListener(marker, "touchstart", (e: TouchEvent) => {
                    dragOrigin = getTouchX(e)
                    rect = bar.getBoundingClientRect()
                }),

                addListener(doc, "touchend", () => {
                    dragOrigin = rect = undefined
                }),

                addListener(doc, "touchmove", (e: TouchEvent) => handleMove(e, getTouchX(e))),

                addListener(bar, "mousedown", (e: MouseEvent) => {
                    rect = bar.getBoundingClientRect()
                    setOpacityFromClientX(e.clientX)
                })

            ]


        }
    }

}

function getTouchX(e: TouchEvent) {
    if (e && e.touches && (e.touches.length == 1)) {
        const t0 = e.touches[0]
        return t0.clientX
    }
}
